export default __webpack_public_path__ + "static/arevivalofegyptsnubianculture-8a9747581d737a6fe9ad7444a529f628.jpg";